const TICKER_ITEMS = [
  "✓ APP Compliant",
  "✓ HIPAA Compliant",
  "✓ SOC 2 Type 1 Certified",
  "✓ 9+ Languages",
  "✓ SOAP Notes",
  "✓ Easy to Use",
];

const FeatureTicker = ({ dark = true }) => {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];

  const borderClass = dark
    ? "border-white/[0.12]"
    : "border-gray-400/40";
  const textClass = dark ? "text-white/75" : "text-gray-600";

  return (
    <div
      aria-hidden="true"
      className={`overflow-hidden border-y border-dashed ${borderClass} py-2`}
    >
      <div className="flex animate-marquee whitespace-nowrap">
        {doubled.map((item, i) => (
          <span key={i} className={`text-xs ${textClass} shrink-0 mr-8`}>
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

export default FeatureTicker;
